/**
 * 营销管理 Saga集合
 */
import accumulaterule from './accumulaterule/model';
import cardcentre from './cardcentre/model';
import eventtouch from './eventtouch/model';

export default [
    ...Object.values(accumulaterule.sagas), // 积分规则
    ...Object.values(cardcentre.sagas), // 卡券中心
    ...Object.values(eventtouch.sagas), // 事件触达
];
